/* tslint:disable */
/* eslint-disable */
/**
 *
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface LabelCategory
 */
export interface LabelCategory {
  /**
   *
   * @type {string}
   * @memberof LabelCategory
   */
  label: string;
  /**
   *
   * @type {string}
   * @memberof LabelCategory
   */
  description: string;
  /**
   *
   * @type {string}
   * @memberof LabelCategory
   */
  color?: string;
}

/**
 * Check if a given object implements the LabelCategory interface.
 */
export function instanceOfLabelCategory(value: object): value is LabelCategory {
  if (!("label" in value) || value["label"] === undefined) return false;
  if (!("description" in value) || value["description"] === undefined) return false;
  return true;
}

export function LabelCategoryFromJSON(json: any): LabelCategory {
  return LabelCategoryFromJSONTyped(json, false);
}

export function LabelCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): LabelCategory {
  if (json == null) {
    return json;
  }
  return {
    label: json["label"],
    description: json["description"],
    color: json["color"] == null ? undefined : json["color"],
  };
}

export function LabelCategoryToJSON(json: any): LabelCategory {
  return LabelCategoryToJSONTyped(json, false);
}

export function LabelCategoryToJSONTyped(
  value?: LabelCategory | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    label: value["label"],
    description: value["description"],
    color: value["color"],
  };
}
